module.exports = __webpack_public_path__ + "img/banner.794967dd.jpg";